<template>
  <aside
    class="my-3 border-0 sidenav navbar _sidebarBg navbar-vertical _custom-scroll navbar-expand-xs border-radius-xl"
    :class="[isRTL ? 'me-3 rotate-caret' : 'ms-3']"
    id="sidenav-main"
    style="overflow-y: auto !important; overflow-x: hidden"
  >
    <div>
      <div class="sidenav-header">
        <i
          class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
          aria-hidden="true"
          id="iconSidenav"
        ></i>
        <div class="d-flex">
          <a class="m-0 navbar-brand d-flex align-items-center" href="/">
            <img
              :src="logo"
              class="navbar-brand-img h-100 rounded-circle"
              alt="main_logo"
            />
            <span class="ms-1 font-weight-bold" style="font-size: 20px"
              >OLT Care</span
            >
          </a>
          <a
            href="#"
            @click="toggleSidebar"
            class="pt-3 nav-link text-body d-block d-xl-none"
            style="padding-left: 50px !important"
            id="iconNavbarSidenav"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </a>

          <!-- trigger btn -->
        </div>
      </div>
      <hr class="mt-0 horizontal dark" />
      <sidenav-list :cardBg="customClass" />
    </div>
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logos/logo.jpg";
import { mapState } from "vuex";
import { mapMutations, mapActions } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      darkMode: false,
    };
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },

  methods: {
    ...mapMutations([
      "navbarMinimize",
      "toggleConfigurator",
      "sidebarExpand",
      "sidebarPin",
    ]),
    ...mapActions(["toggleSidebarColor"]),
    ...mapState(["isRTL", "isPinned"]),

    toggleSidebar() {
      if (this.darkMode == false) {
        this.toggleSidebarColor("bg-white");
      } else {
        this.toggleSidebarColor("bg-dark");
      }
      this.navbarMinimize();
    },
  },
  mounted() {
    const savedDarkMode = localStorage.getItem("darkMode");
    if (savedDarkMode !== null) {
      this.darkMode = JSON.parse(savedDarkMode); // Update dark mode state
    }

    const pinned = JSON.parse(localStorage.getItem("isPinned"));

    if (pinned) {
      this.sidebarPin();
    }
  },
  computed: {
    ...mapState(["isRTL"]),
  },
};
</script>
<style scoped>
.rounded-circle {
  border-radius: 50%;
}

/* Custom Scrollbar Styles */
._custom-scroll::-webkit-scrollbar {
  width: 8px !important; /* Width of the scrollbar */
}

._custom-scroll::-webkit-scrollbar-thumb {
  background-color: #555 !important;
  border-radius: 4px !important;
}

._custom-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #888 !important;
}

._custom-scroll::-webkit-scrollbar-track {
  background-color: #9e9c9cbd !important; /* Slightly darker track */
  border-radius: 4px !important; /* Rounded corners for the track */
}

._sidebarBg {
  background-color: white !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.dark-mode ._sidebarBg {
  background-color: #344767 !important;
}
</style>
